<template>
  <Card class="cardClass">
    <template slot="content">
      <div class="grid">
        <div class="lg:col-2 sm:col-12 autoMargin">
          <span class="dot lightBlueBG autoMargin center">
            <div>
              <strong class="circleTextBigFont">{{
                precio | toCurrency("es-ES", divisa)
              }}</strong>
              <br />
              <small class="circleTextSmallFont">{{
                $t("altaImpago.sinIVA")
              }}</small>
            </div>
          </span>
        </div>
        <div class="lg:col-6 sm:col-12 description">
          <h2 class="titles">{{ nombre }}</h2>
          <p class="explanation">{{ descripcion }}</p>
        </div>
        <div class="lg:col-4 sm:col-12 center autoMargin">
          <Button
            @click="decidirDondeIr(tipoContrato)"
            :label="'SOLICITAR'"
            class="buttonStyle"
          />
        </div>
      </div>
    </template>
  </Card>
</template>

<script>
import RoutesMixin from "@/utils/routes";
import { CODIGOS_PROMOCIONALES,TIPOS_PRODUCTOS_TIPO_SERVICIO } from "@/resources/constants";
import { QUERY_BONOS_APLICABLES } from "@/graphQLQueries/FacturaQueries";
import CurrencyMixin from "@/utils/currency";

export default {
  name: "CardReclamacion",
  mixins: [RoutesMixin, CurrencyMixin],
  props: {
    tipoContrato: String,
    tipo: String,
    precio: Number,
    divisa: {
      type: String,
      default: "EUR",
    },
    nombre: String,
    descripcion: String,
  },
  data() {
    return {
      promotorEinforma: CODIGOS_PROMOCIONALES.EINFORMA,
      esMayorista: this.$store.state.esMayorista,
      claimTypes: [
        {
          code: "basic",
          internalValue: "ICIRED_BASICO",
        },
        {
          code: "burofax",
          internalValue: "ICIRED_BUROFAX",
        },
        {
          code: "notarial",
          internalValue: "ICIRED_NOTARIAL",
        },
      ],
    };
  },
  methods: {
    decidirDondeIr(tipoContrato) {
      if (this.tipo.toLowerCase() === TIPOS_PRODUCTOS_TIPO_SERVICIO.CONSULTA) {
        this.goToNewConsultaTercerosParam(tipoContrato);
      } else {
        if (!this.$store.state.esMayorista) {
          if (this.$store.state.codigoPromotor == this.promotorEinforma) {
            //Si tiene bono aplicable new draft, en caso contrario a einforma

            this.checkBonosAplicables(tipoContrato);
          } else {
            this.goToNewDraftView(tipoContrato, "creditor");
          }
        } else {
          //TODO dejarlo bien
          alert(
            "Un cliente de tipo mayorista no puede dar de alta reclamaciones a través de la web."
          );
        }
      }
    },
    checkBonosAplicables(tipoContrato) {
      this.$apollo
        .query({
          query: QUERY_BONOS_APLICABLES,
          variables: {
            uuid: this.$store.state.profile.uuid,
            codigoProducto: tipoContrato,
          },
        })
        .then((response) => {
          var bonoAplicable = response.data.bonosAplicables.find(
            (b) => b.encontrado
          );

          if (!bonoAplicable) {
            window.location.replace(process.env.VUE_APP_EINFORMA_LINK_URL);
          } else {
            this.goToNewDraftView(tipoContrato, "creditor");
          }
        })
        .catch((error) => {
          console.error(error);

          this.$toast.add({
            severity: "error",
            summary: this.$t("mensajesTOS.errorActualizacionTosnombre"),
            detail: this.$t("mensajesTOS.errorActualizacionTos"),
            life: 5000,
          });
        });
    },
  },
};
</script>